export default class ViewportWatcher {
    constructor(variable, update) {
        this.variable = variable;
        this.update = update;

        this.addEvents();
        this.watch();
    }

    addEvents() {
        if (this.update) {
            window.addEventListener('resize', () => {
                this.watch();
            });
        }
    }

    watch() {
        document.body.style.setProperty(this.variable, `${window.innerHeight}px`);
    }
}
